/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_04_SummaryInputs */

const en_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After impact, arms fold, wrists release, and eyes track the ball. That's the swing working correctly.`)
};

const es_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Después del impacto, los brazos se pliegan, las muñecas se liberan y los ojos siguen la bola. Así es como el swing funciona correctamente.`)
};

const de_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach dem Treffmoment knicken die Arme ein, die Handgelenke lösen sich und die Augen folgen dem Ball. So arbeitet der Schwung richtig.`)
};

const zh_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`击球瞬间之后，手臂折叠、手腕释放、眼睛追踪球。这就是挥杆在正确地运作。`)
};

const ar_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بعد لحظة الضرب، تنثني الذراعان وتُطلق المعاصم وتتبع العينان الكرة. هكذا يعمل السوينغ بشكل صحيح.`)
};

const fr_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Après l’impact, les bras se replient, les poignets se relâchent et les yeux suivent la balle. C'est le swing qui fonctionne correctement.`)
};

const vi_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sau impact, cánh tay gập, cổ tay nhả, và mắt theo bóng. Đó là swing hoạt động đúng.`)
};

const sw_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baada ya kugonga mpira, mikono hukunjika, vifundo vya mikono huachia, na macho hufuatilia mpira. Hiyo ndiyo swing inayofanya kazi ipasavyo.`)
};

const th_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หลังจังหวะอิมแพ็ค แขนพับ ข้อมือปล่อย และสายตามองตามลูก นั่นคือสวิงที่ทำงานอย่างถูกต้อง`)
};

const bs_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslije impacta, ruke se savijaju, zapešća se otpuštaju i oči prate loptu. Tako swing radi ispravno.`)
};

const ja_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インパクトのあと、腕は畳まれ、手首はリリースし、目はボールを追います。それが正しく働いているスイングです。`)
};

const ko_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`임팩트 후 팔이 접히고, 손목이 풀리며, 눈은 공을 따라갑니다. 이것이 스윙이 제대로 작동하는 모습입니다.`)
};

const pt_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depois do impacto, os braços se dobram, os punhos liberam e os olhos acompanham a bola. É assim que o swing funciona corretamente.`)
};

const it_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dopo l'impatto le braccia si piegano, i polsi rilasciano e gli occhi seguono la palla. È lo swing che funziona come deve.`)
};

const sv_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Efter träffögonblicket viker sig armarna, handlederna frisläpps och ögonen följer bollen. Så fungerar svingen korrekt.`)
};

const nl_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na het trefmoment vouwen de armen, laten de polsen los en volgen de ogen de bal. Zo werkt de swing correct.`)
};

const da_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Efter træfmomentet folder armene, håndleddene frigives, og øjnene følger bolden. Sådan arbejder svinget korrekt.`)
};

const nb_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etter treffpunktet folder armene seg, håndleddene frigjøres og øynene følger ballen. Slik fungerer svingen riktig.`)
};

const fi_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osuman jälkeen kädet koukistuvat, ranteet vapautuvat ja silmät seuraavat palloa. Silloin svingi toimii oikein.`)
};

const pl_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Po uderzeniu ręce się zginają, nadgarstki się uwalniają, a oczy śledzą piłkę. Tak wygląda prawidłowo działający swing.`)
};

const ru_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`После удара руки складываются, запястья освобождаются, а глаза следят за мячом. Так работает правильный свинг.`)
};

const tr_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuruştan sonra kollar katlanır, bilekler serbest kalır ve gözler topu takip eder. Doğru çalışan swing budur.`)
};

const hi_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इम्पैक्ट के बाद बाँहें मुड़ती हैं, कलाईयाँ रिलीज़ होती हैं, और आँखें गेंद का पीछा करती हैं। यही सही ढंग से काम करता स्विंग है।`)
};

const id_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setelah impact, lengan menekuk, pergelangan tangan terlepas, dan mata mengikuti bola. Itulah ayunan yang bekerja dengan benar.`)
};

const ms_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selepas hentaman, lengan melipat, pergelangan tangan dilepaskan dan mata mengekori bola. Itulah hayunan yang berfungsi dengan betul.`)
};

const cs_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Po úderu se paže skládají, zápěstí se uvolňují a oči sledují míč. Takhle švih funguje správně.`)
};

const el_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μετά την επαφή, τα χέρια διπλώνουν, οι καρποί απελευθερώνονται και τα μάτια ακολουθούν την μπάλα. Έτσι λειτουργεί σωστά το σβινγκ.`)
};

const he_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אחרי הפגיעה הזרועות מתקפלות, פרקי הידיים משתחררים והעיניים עוקבות אחרי הכדור. כך הסווינג עובד כמו שצריך.`)
};

const af_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ná impak vou die arms, laat die polse los, en volg die oë die bal. Dit is die swaai wat reg werk.`)
};

const hu_method_content_step_04_summary = /** @type {(inputs: Method_Content_Step_04_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Találat után a karok behajlanak, a csuklók oldanak, a szemek követik a labdát. Így dolgozik helyesen a swing.`)
};

/**
* | output |
* | --- |
* | "After impact, arms fold, wrists release, and eyes track the ball. That's the swing working correctly." |
*
* @param {Method_Content_Step_04_SummaryInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_04_summary = /** @type {((inputs?: Method_Content_Step_04_SummaryInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_04_SummaryInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_04_summary(inputs)
	if (locale === "de") return de_method_content_step_04_summary(inputs)
	if (locale === "zh") return zh_method_content_step_04_summary(inputs)
	if (locale === "ar") return ar_method_content_step_04_summary(inputs)
	if (locale === "fr") return fr_method_content_step_04_summary(inputs)
	if (locale === "vi") return vi_method_content_step_04_summary(inputs)
	if (locale === "sw") return sw_method_content_step_04_summary(inputs)
	if (locale === "th") return th_method_content_step_04_summary(inputs)
	if (locale === "bs") return bs_method_content_step_04_summary(inputs)
	if (locale === "ja") return ja_method_content_step_04_summary(inputs)
	if (locale === "ko") return ko_method_content_step_04_summary(inputs)
	if (locale === "pt") return pt_method_content_step_04_summary(inputs)
	if (locale === "it") return it_method_content_step_04_summary(inputs)
	if (locale === "sv") return sv_method_content_step_04_summary(inputs)
	if (locale === "nl") return nl_method_content_step_04_summary(inputs)
	if (locale === "da") return da_method_content_step_04_summary(inputs)
	if (locale === "nb") return nb_method_content_step_04_summary(inputs)
	if (locale === "fi") return fi_method_content_step_04_summary(inputs)
	if (locale === "pl") return pl_method_content_step_04_summary(inputs)
	if (locale === "ru") return ru_method_content_step_04_summary(inputs)
	if (locale === "tr") return tr_method_content_step_04_summary(inputs)
	if (locale === "hi") return hi_method_content_step_04_summary(inputs)
	if (locale === "id") return id_method_content_step_04_summary(inputs)
	if (locale === "ms") return ms_method_content_step_04_summary(inputs)
	if (locale === "cs") return cs_method_content_step_04_summary(inputs)
	if (locale === "el") return el_method_content_step_04_summary(inputs)
	if (locale === "he") return he_method_content_step_04_summary(inputs)
	if (locale === "af") return af_method_content_step_04_summary(inputs)
	if (locale === "hu") return hu_method_content_step_04_summary(inputs)
	return en_method_content_step_04_summary(inputs)
});